export default __webpack_public_path__ + "static/media/10.7f1a000c.png";